import React from "react";
import "./Videos.scss";
import { Suspense, lazy } from "react";
import Rightbar from "../../components/Rightbar/Rightbar";
import Globals from "../../api";
import ImageConvertionDefault from "../../config";
import ROS_Middle_Center_336_280 from '../ad-units/ros_middle_center_728_90';
import Ros_bottom_center_728_90 from '../ad-units/Ros_bottom_center_728_90';
export default class VideoListing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videoData: [],
      page: 1,
      Rightbar : [],
      AdData : []
    };
  }
  getAds(){
    const url= Globals.AdConfig;
            fetch(url)
            .then((res) => res.json())
            .then((data) => {
              
                this.setState({
                  AdData : data.AdContents[0].ROS
                })
                
            }) 
            
  } 
  getRightbar(){
    const url= Globals.Rightbar_api+"/latest-kannada-news";
    fetch(url)
    .then((res) => res.json())
    .then((data) => {
        
        this.setState({
          Rightbar : data.Contents[0]
        })
    })   
  }    
  componentDidMount() {
   // let url = window.location.pathname;
    const videoListURL = Globals.language_based_api + "/videos";
    //const videoListURL = 'http://ws-uat.webdunia.com/json/page?lang=te&url=/videos';
    fetch(videoListURL)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          videoData: data.Contents[2].out.list,
          page: 1,
        });
      });
    window.addEventListener("scroll", this.trackScrolling);
    this.getRightbar();
    this.getAds();

  }

  trackScrolling = () => {
    const wrappedElement = document.getElementById("videoDiv");
    if (this.isBottom(wrappedElement)) {
      let newPage = this.state.page;
      newPage++;
      this.setState({
        page: newPage,
      });
      this.nextPageData(newPage);
      window.removeEventListener("scroll", this.trackScrolling);
    }
  };
  componentWillUnmount() {
    window.removeEventListener("scroll", this.trackScrolling);
  }
  isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  }
  nextPageData(page) {
    let url = window.location.pathname;
    //const videoListURL = 'http://ws-uat.webdunia.com/json/page?lang=te&url=/videos' + "/" + page;
    const videoListURL = Globals.language_based_api + url + "/" + page;
    console.log("next-page", videoListURL)
    fetch(videoListURL)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          videoData: [...this.state.videoData, ...data.Contents[2].out.list],
          nextPage: true,
        });
        if (this.state.videoData) {
          window.location.url = this.state.videoData;
          window.addEventListener("scroll", this.trackScrolling);
        }
      });
  }

  render() {
    let videoList = this.state.videoData;
    const renderLoader = () => <p>Loading</p>;
    return (
      <div className="container padding15" id="videoDiv">
        <div className="row">
          <div className="col">
            <h2 className="video_page_title">ವಿಡಿಯೋಗಳು</h2>
            <ul className="videos_listing">
              {this.state.videoData.map((item, i) => (
                <>
                {(() => {
       // i =   i-1;
                if (i % 6 == 0  && i != 0) {
                  return (
                    <>
              <div className="ads_between_list"  >
              <Suspense fallback={renderLoader()}>
              <ROS_Middle_Center_336_280 AdData= {this.state.AdData} />
              </Suspense>
               </div>
               <br />
              </>
                  )
                 
                } 
              //    else if (i % 15 == 2) {
              //     return (
              //   <div className="ads_between_list" > 
              //  <Suspense fallback={renderLoader()}>
              //  <Ros_bottom_center_728_90 AdData= {this.state.AdData}/>
              //  </Suspense>
              //       </div>
              //     )
                 
              //   }
                
              })()}
                <li>
                  <a href={`/wdvideo/${item.videoid}`}>
                  <div className="videos_block">
                    <span className="video_b_thumb">
                      <img
                        src={item.thumbnail_480_url}
                      />
                    </span>
                    <h3>
                      <a href={`/wdvideo/${item.videoid}`}>{item.title}</a>
                    </h3>
                  </div>
                  </a>
                </li>
                </>
              ))}
            </ul>
          </div>
          <div className="col right_side_bar">
          <Rightbar Rightbar={this.state.Rightbar} googleAds = {this.state.AdData}/>
          </div>
        </div>
      </div>
    );
  }
}
